import { render } from "./CollectionsContainer.vue?vue&type=template&id=3d9e3de6&scoped=true"
import script from "./CollectionsContainer.vue?vue&type=script&lang=js"
export * from "./CollectionsContainer.vue?vue&type=script&lang=js"

import "./CollectionsContainer.vue?vue&type=style&index=0&id=3d9e3de6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9e3de6"]])

export default __exports__